import { render, staticRenderFns } from "./UpdateFee.vue?vue&type=template&id=28245de6&"
import script from "./UpdateFee.vue?vue&type=script&lang=js&"
export * from "./UpdateFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports